module.exports = __webpack_public_path__ + "img/progress.15369cda.png";